import InstallationServices from "@/components/InstallationServices/installationServices";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useToast } from "@/components/ui/use-toast";
import { cn } from "@/lib/utils";
import { useGetWarrentyAndServicesQuery } from "@/redux/apiSlices/supportApi";
import { useUpdateCartMutation } from "@/redux/apiSlices/userCartApi";
import { useEffect, useState } from "react";

const EditAddOnServices = ({
  productId,
  categoryId,
  subCategoryId,
  selectedWarrantyId,
  quantity,
  selectedAdditionalServiceId,
  selectedInstallationServiceId,
  categoryName,
  additionalServicesData,
  quoteOnly,
  selectedinstallationParts,
}) => {
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  return (
    <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
      <SheetTrigger asChild>
        <button
          className={cn(
            " text-[15px] leading-[23px] text-blue5 lg:text-[14px] lg:leading-[21px] hover:underline hover:underline-offset-2"
          )}
        >
          {!selectedAdditionalServiceId &&
          !selectedInstallationServiceId &&
          !quoteOnly &&
          !selectedinstallationParts?.length
            ? "Add Services"
            : "Edit Services"}
        </button>
      </SheetTrigger>
      <SheetContent className="w-[500px] p-0 rounded-20">
        <SheetBody
          selectedInstallationServiceId={selectedInstallationServiceId}
          selectedAdditionalServiceId={selectedAdditionalServiceId}
          selectedinstallationParts={selectedinstallationParts}
          quoteOnly={quoteOnly}
          categoryName={categoryName}
          additionalServicesData={additionalServicesData}
          productId={productId}
          categoryId={categoryId}
          subCategoryId={subCategoryId}
          selectedWarrantyId={selectedWarrantyId}
          quantity={quantity}
          setIsSheetOpen={setIsSheetOpen}
        />
      </SheetContent>
    </Sheet>
  );
};

export default EditAddOnServices;

const SheetBody = ({
  productId,
  categoryId,
  subCategoryId,
  quoteOnly = false,
  quantity,
  setIsSheetOpen,
  categoryName,
  selectedAdditionalServiceId,
  selectedInstallationServiceId = null,
  additionalServicesData,
  selectedinstallationParts = [],
}) => {
  const { toast } = useToast();

  const [updateCart, { isSuccess, isLoading }] = useUpdateCartMutation();

  const { data, isFetching } = useGetWarrentyAndServicesQuery({
    categoryId,
    subCategory: subCategoryId,
    productId,
  });

  const { addOnServices = [] } = data?.data || {};

  const [addOnsPayload, setAddOnsPayload] = useState({
    installationServiceId: selectedInstallationServiceId,
    installationParts: selectedinstallationParts || [],
    additionServices: {
      haulaway: additionalServicesData?.haulAway || false,
      moveAway: additionalServicesData?.moveAway || false,
      additionalServiceId: selectedAdditionalServiceId,
    },
    quoteOnly,
  });

  const handleUpdateServices = () => {
    const { installationParts, installationService, ...extraPayloads } =
      addOnsPayload;
    const updateCartPayload = {
      products: [
        {
          productId: Number(productId),
          quantity,
          ...extraPayloads,
          installationParts: installationParts.map(
            (part) => part.partId || part
          ),
        },
      ],
    };
    updateCart(updateCartPayload);
  };

  useEffect(() => {
    if (isSuccess && data?.success) {
      setIsSheetOpen(false);
      toast({
        title: data?.message || "Services updated successfully",
      });
    }
  }, [isSuccess]);

  return (
    <>
      <InstallationServices
        isFetching={isFetching}
        addOnsPayload={addOnsPayload}
        setAddOnsPayload={setAddOnsPayload}
        categoryName={categoryName}
        addOnServices={addOnServices}
      />
      <div className="flex justify-end px-6 pt-[17px]">
        <Button
          onClick={handleUpdateServices}
          disabled={isLoading || isFetching}
          className=" bg-red3 h-[50px] rounded-10 min-w-[191px] text-[14px] leading-[21px] text-white font-medium"
        >
          {!selectedAdditionalServiceId && !selectedInstallationServiceId
            ? "Add Services"
            : "Update Services"}{" "}
        </Button>
      </div>
    </>
  );
};
